module.exports = __webpack_public_path__ + "img/results_pull_ext.15b734b7.png";